/* Large slab photographs load only when requested. Thumbnail links work without JS. */
(() => {
  if (document.documentElement.dataset.sgViewerBound) return;
  document.documentElement.dataset.sgViewerBound = 'true';
  let dialog, photo, stage, caption, status, toggle, zoom, previous, next, original;
  let items = [], index = 0, backlit = false, request = 0, opener, overflow;

  function createViewer() {
    dialog = document.createElement('dialog');
    dialog.className = 'sg-viewer';
    dialog.setAttribute('aria-label', 'Slab photograph viewer');
    dialog.innerHTML = `
      <div class="sg-viewer__panel">
        <header class="sg-viewer__header">
          <p class="sg-viewer__caption" aria-live="polite"></p>
          <button type="button" data-close aria-label="Close image viewer" autofocus>Close ×</button>
        </header>
        <div class="sg-viewer__stage"><img class="sg-viewer__image" alt=""></div>
        <p class="sg-viewer__status" role="status"></p>
        <footer class="sg-viewer__controls">
          <button type="button" data-previous aria-label="Previous photograph">← Previous</button>
          <button type="button" data-next aria-label="Next photograph">Next →</button>
          <button type="button" data-backlit aria-pressed="false">Show backlit</button>
          <button type="button" data-zoom aria-pressed="false">Zoom in</button>
          <a data-original target="_blank" rel="noopener">Open full image ↗</a>
        </footer>
      </div>`;
    document.body.append(dialog);
    photo = dialog.querySelector('img');
    stage = dialog.querySelector('.sg-viewer__stage');
    caption = dialog.querySelector('.sg-viewer__caption');
    status = dialog.querySelector('[role="status"]');
    toggle = dialog.querySelector('[data-backlit]');
    zoom = dialog.querySelector('[data-zoom]');
    previous = dialog.querySelector('[data-previous]');
    next = dialog.querySelector('[data-next]');
    original = dialog.querySelector('[data-original]');
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    toggle.addEventListener('click', () => { backlit = !backlit; render(); });
    zoom.addEventListener('click', () => setZoom(!stage.classList.contains('is-zoomed')));
    photo.addEventListener('click', () => setZoom(!stage.classList.contains('is-zoomed')));
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      request++;
      document.body.style.overflow = overflow;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        if (stage.classList.contains('is-zoomed')) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
  }

  function setZoom(enabled) {
    stage.classList.toggle('is-zoomed', enabled);
    zoom.setAttribute('aria-pressed', String(enabled));
    zoom.textContent = enabled ? 'Fit image' : 'Zoom in';
    stage.scrollTop = stage.scrollLeft = 0;
  }

  function move(direction) {
    index = (index + direction + items.length) % items.length;
    backlit = false;
    render();
  }

  function render() {
    const item = items[index];
    const paired = Boolean(item.dataset.sgBacklit);
    backlit = backlit && paired;
    const url = backlit ? item.dataset.sgBacklit : item.href;
    const thumb = item.querySelector(backlit ? '.sg-tile__img--backlit' : '.sg-tile__img--normal');
    const label = item.dataset.sgLabel || item.getAttribute('aria-label') || 'Slab photograph';
    const current = ++request;
    setZoom(false);
    caption.textContent = `${label}${backlit ? ' · Backlit' : ''} — ${index + 1} / ${items.length}`;
    toggle.hidden = !paired;
    toggle.setAttribute('aria-pressed', String(backlit));
    toggle.textContent = backlit ? 'Show natural light' : 'Show backlit';
    previous.hidden = next.hidden = items.length < 2;
    original.href = url;
    photo.alt = label + (backlit ? ', backlit' : '');
    photo.src = thumb ? (thumb.currentSrc || thumb.src) : url;
    status.textContent = 'Loading full image…';
    stage.setAttribute('aria-busy', 'true');
    const full = new Image();
    full.onload = () => {
      if (current !== request || !dialog.open) return;
      photo.src = url;
      stage.setAttribute('aria-busy', 'false');
      status.textContent = '';
    };
    full.onerror = () => {
      if (current !== request || !dialog.open) return;
      stage.setAttribute('aria-busy', 'false');
      status.textContent = 'The full image could not load. Preview shown; try Open full image.';
    };
    full.src = url;
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sg-zoom]');
    const gallery = link && link.closest('[data-sg-gallery]');
    if (!gallery || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    if (!dialog) createViewer();
    items = Array.from(gallery.querySelectorAll('[data-sg-zoom]'));
    index = items.indexOf(link);
    opener = link;
    backlit = Boolean(link.dataset.sgBacklit) && event.detail > 0 && window.matchMedia('(hover: hover) and (pointer: fine)').matches && link.matches(':hover');
    overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    render();
  });
})();
